import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

const BusinessModal = ({
  modalToggle, cancelDelete, deleteBusinessName, confirmDeleteBusiness
}) => (
    <Modal visible={modalToggle} onClickBackdrop={this.modalBackdropClicked}>
      <div className="modal-header">
        <h5 className="modal-title">Delete Business? </h5>
        <span onClick={cancelDelete} className="close-delete-popup cursor-pointer">X</span>
      </div>
      <div className="modal-body">
        <p>
          Are you sure you want to delete the business{' '}
          <span className="font-weight-bold">{deleteBusinessName}</span>?
        </p>
        <p>(Deleting this Business will delete all questions and reports related to it.)</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={cancelDelete}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={confirmDeleteBusiness}>
          Delete
        </button>
      </div>
    </Modal >
  );


export default BusinessModal;

BusinessModal.propTypes = {
  modalToggle: PropTypes.bool,
  deleteBusinessName: PropTypes.string,
  cancelDelete: PropTypes.func,
  confirmDeleteBusiness: PropTypes.func,
};

BusinessModal.defaultProps = {
  modalToggle: () => { },
  deleteBusinessName: '',
  cancelDelete: () => { },
  confirmDeleteBusiness: () => { }
}



// WEBPACK FOOTER //
// ./src/components/businesses/BusinessModal.js